import {useNavigate} from "react-router";
import {getI18n, useTranslation} from "react-i18next";

export default function HeaderNav({ navs, type, style, navStyle }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = getI18n().language
  
  return (
    <div className={'container-center ml-[20px] md:flex lg:max-w-[1000px] lg:pb-[20px] md:pb-[10px] mdmax:hidden'} style={style}>
      {
        navs.map((item, index) => (
          <a key={index}
             onClick={() => navigate(item.path)}
             style={navStyle}
             className={`link px-[30px] text-center text-[14px] xl:text-[16px] ${type === 'home' ? 'text-white text-shadow-normal' : 'text-[#333]'}`}>
            {lang === 'en' ? item.nameEN : item.name}
          </a>
        ))
      }
    </div>
  );
}
